import { GET, POST } from './utils';

// token is the JWT embedded in the URL — it IS the auth, no access_token header needed
// eslint-disable-next-line no-undef
const getAPIURL = (path) => `${process.env.REACT_APP_API_URL}/${path}`;

export const GET_VERIFICATION = ({ token }) =>
  GET({ raw_url: getAPIURL(`rental-verification/${token}`), autoLogOut: false });

export const SUBMIT_VERIFICATION = ({ token, data }) =>
  POST({ raw_url: getAPIURL(`rental-verification/${token}/submit`), data, autoLogOut: false });
